import List from "@material-ui/core/List";
import {IconButton, ListItem, Tooltip, Typography} from "@material-ui/core";
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import Grid from "@material-ui/core/Grid";
import {useHourglassIconAndTooltipCellStyles} from "./HourglassiconAndTooltipCellStyles";

const HourglassIconAndTooltipCell = (props) => {
    const classes = useHourglassIconAndTooltipCellStyles();

    const tooltipContent = (
        <>
            <Typography variant={"subtitle2"} className={classes.title}>Una lavorazione è in
                corso</Typography>
            <List className={classes.list}>
                {props.tooltipContent.map((content, idx) => (
                    <ListItem key={"status-wrench-tooltip-" + idx}
                              className={classes.listItem}>
                        <Grid container alignItems="center">
                            <Grid item xs={6}>
                                <Typography className={classes.textLeft}
                                            variant="subtitle2">{content.textLeft}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"
                                            className={classes.textRight}>{content.textRight}</Typography>
                            </Grid>
                        </Grid>
                    </ListItem>
                ))}
            </List>
        </>
    )

    return (
        <Tooltip title={tooltipContent} arrow>
            <IconButton className={classes.iconButton} onClick={(e) => e.stopPropagation()}>
                <HourglassEmptyIcon color='primary'/>
            </IconButton>
        </Tooltip>
    )
}

export default HourglassIconAndTooltipCell;
